(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["entertainment-release"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-release-guide')) {
    customElements.define('pk-release-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const source = this.querySelector('[data-guide-data]');
        if (!source) return;
        let data;
        try { data = JSON.parse(source.textContent); } catch { return; }
        const eligible = new Set(data.eligible || []);
        const rows = (data.rows || []).filter(row => eligible.has(row.set));
        const body = this.querySelector('[data-checklist-body]');
        const search = this.querySelector('[data-checklist-search]');
        const select = this.querySelector('[data-checklist-set]');
        const count = this.querySelector('[data-checklist-count]');
        const previous = this.querySelector('[data-page-prev]');
        const next = this.querySelector('[data-page-next]');
        let page = 0;
        const size = 20;
        const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        if (body && search && select && count && previous && next) {
          const render = () => {
            const query = normalize(search.value.trim());
            const matches = rows.filter(row => (!select.value || row.set === select.value) && (!query || normalize(row.subject + ' ' + row.number + ' ' + row.set).includes(query)));
            page = Math.min(page, Math.max(0, Math.ceil(matches.length / size) - 1));
            const visible = matches.slice(page * size, (page + 1) * size);
            const fragment = document.createDocumentFragment();
            visible.forEach(row => {
              const tr = document.createElement('tr');
              [row.number, row.subject, row.set].forEach(value => { const td = document.createElement('td'); td.textContent = value; tr.append(td); });
              fragment.append(tr);
            });
            body.replaceChildren(fragment);
            const start = matches.length ? page * size + 1 : 0;
            const end = Math.min((page + 1) * size, matches.length);
            count.textContent = count.dataset.countTemplate.replace('__START__', start).replace('__END__', end).replace('__COUNT__', matches.length);
            previous.disabled = page === 0;
            next.disabled = (page + 1) * size >= matches.length;
            this.querySelector('[data-checklist-empty]').hidden = matches.length !== 0;
          };
          search.addEventListener('input', () => { page = 0; render(); });
          select.addEventListener('change', () => { page = 0; render(); });
          previous.addEventListener('click', () => { page = Math.max(0, page - 1); render(); });
          next.addEventListener('click', () => { page += 1; render(); });
          this.querySelector('[data-checklist-controls]').hidden = false;
          this.querySelector('[data-checklist-pagination]').hidden = false;
          render();
        }
        const dialog = this.querySelector('dialog');
        const zoomedImage = this.querySelector('[data-dialog-image]');
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-card-image]');
          if (!trigger || !dialog || !zoomedImage) return;
          zoomedImage.src = trigger.dataset.cardImage;
          zoomedImage.alt = trigger.dataset.cardAlt;
          dialog.showModal();
        });
        this.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        const back = this.querySelector('.pk-guide__bottom a');
        const productInfo = document.querySelector('[id^="ProductInformation-"]');
        if (back && productInfo) back.href = '#' + productInfo.id;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pokemon-chase-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-pokemon-guide')) {
    customElements.define('pk-pokemon-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        let rows;
        try { rows = JSON.parse(this.querySelector('[data-guide-data]').textContent); } catch { return; }
        if (!Array.isArray(rows)) return;
        const body = this.querySelector('[data-checklist-body]');
        const search = this.querySelector('[data-checklist-search]');
        const select = this.querySelector('[data-checklist-set]');
        const count = this.querySelector('[data-checklist-count]');
        const previous = this.querySelector('[data-page-prev]');
        const next = this.querySelector('[data-page-next]');
        const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        let page = 0;
        const size = 20;
        if (body && search && select && count && previous && next) {
          const render = () => {
            const query = normalize(search.value.trim());
            const matches = rows.filter(row => (!select.value || row.set === select.value) && (!query || normalize(row.subject + ' ' + (row.native || '') + ' ' + row.number + ' ' + row.set).includes(query)));
            page = Math.min(page, Math.max(0, Math.ceil(matches.length / size) - 1));
            const fragment = document.createDocumentFragment();
            matches.slice(page * size,(page + 1) * size).forEach(row => {
              const tr = document.createElement('tr');
              [row.number,row.subject,row.set].forEach(value => { const td = document.createElement('td'); td.textContent = value; tr.append(td); });
              fragment.append(tr);
            });
            body.replaceChildren(fragment);
            count.textContent = count.dataset.countTemplate.replace('__START__',matches.length ? page * size + 1 : 0).replace('__END__',Math.min((page + 1) * size,matches.length)).replace('__COUNT__',matches.length);
            previous.disabled = page === 0;
            next.disabled = (page + 1) * size >= matches.length;
            this.querySelector('[data-checklist-empty]').hidden = matches.length !== 0;
          };
          search.addEventListener('input',() => { page = 0; render(); });
          select.addEventListener('change',() => { page = 0; render(); });
          previous.addEventListener('click',() => { page = Math.max(0,page - 1); render(); });
          next.addEventListener('click',() => { page += 1; render(); });
          this.querySelector('[data-checklist-controls]').hidden = false;
          this.querySelector('[data-checklist-pagination]').hidden = false;
          render();
        }
        const dialog = this.querySelector('dialog');
        const image = this.querySelector('[data-dialog-image]');
        this.addEventListener('click',event => {
          const trigger = event.target.closest('[data-card-image]');
          if (!trigger || !dialog || !image) return;
          image.src = trigger.dataset.cardImage;
          image.alt = trigger.dataset.cardAlt;
          dialog.showModal();
        });
        this.querySelector('[data-close-dialog]')?.addEventListener('click',() => dialog.close());
        dialog?.addEventListener('click',event => { if (event.target === dialog) dialog.close(); });
        const back = this.querySelector('[data-back-to-product]');
        const productInfo = document.querySelector('[id^="ProductInformation-"]');
        if (back && productInfo) back.href = '#' + productInfo.id;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
